module.exports = __webpack_public_path__ + "static/media/roo_wor_saf_sto.57c412b6.png";